export const DATA_NEWS = [
    {
        ImagemUrl: "assets/img/gallery/coopavel_2020.jpeg",
        Descricao: "32⁰ Edição Coopavel 2020",
        Cidade: "Cascavel - PR",
        Data: new Date('2020-02-04')
    }
    , {
        ImagemUrl: "assets/img/gallery/expodireto_2020.jpeg",
        Descricao: "21⁰ Edição Expodireto cotrijal 2020",
        Cidade: "Não Me Toque - RS",
        Data: new Date('2020-03-03')
    }
]